var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-tabs",
        {
          attrs: { "background-color": "blue-grey lighten-5" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { key: "boat_config" }, [_vm._v("Configs")]),
          _c("v-tab", { key: "boat_order" }, [_vm._v("Orders")]),
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "mt-4",
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { key: "boat_config" },
            [_c("r-boat-config-page")],
            1
          ),
          _c("v-tab-item", { key: "boat_order" }, [_c("r-boat-order-page")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }